import { Controller } from "@hotwired/stimulus"

const MAPBOX_CSS = "https://api.mapbox.com/mapbox-gl-js/v3.3.0/mapbox-gl.css"
const MAPBOX_JS = "https://api.mapbox.com/mapbox-gl-js/v3.3.0/mapbox-gl.js"

export default class extends Controller {
  static values = {
    token: String,
    coordinates: Array
  }

  connect() {
    if (!this.hasTokenValue || !this.hasCoordinatesValue || this.coordinatesValue.length < 2) {
      return
    }

    this.ensureMapbox().then(() => this.renderMap()).catch((error) => {
      console.error("Zubie route map failed to load Mapbox:", error)
      this.element.innerHTML = '<p class="u-textRed u-textSmall">Failed to load map.</p>'
    })
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  ensureMapbox() {
    if (window.mapboxgl) {
      return Promise.resolve()
    }

    if (!document.querySelector(`link[href="${MAPBOX_CSS}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = MAPBOX_CSS
      document.head.appendChild(link)
    }

    if (window.__zubieMapboxLoading) {
      return window.__zubieMapboxLoading
    }

    window.__zubieMapboxLoading = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = MAPBOX_JS
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => reject(new Error("Mapbox GL failed to load"))
      document.head.appendChild(script)
    })

    return window.__zubieMapboxLoading
  }

  renderMap() {
    const coords = this.coordinatesValue
    mapboxgl.accessToken = this.tokenValue

    this.map = new mapboxgl.Map({
      container: this.element,
      style: "mapbox://styles/mapbox/streets-v12",
      center: coords[0],
      zoom: 13
    })

    this.map.addControl(new mapboxgl.NavigationControl(), "top-right")

    this.map.on("load", () => {
      this.map.addSource("zubie-route", {
        type: "geojson",
        data: {
          type: "Feature",
          properties: {},
          geometry: { type: "LineString", coordinates: coords }
        }
      })

      this.map.addLayer({
        id: "zubie-route-line",
        type: "line",
        source: "zubie-route",
        layout: { "line-join": "round", "line-cap": "round" },
        paint: { "line-color": "#4264fb", "line-width": 5 }
      })

      new mapboxgl.Marker({ color: "#22c55e" }).setLngLat(coords[0]).addTo(this.map)
      new mapboxgl.Marker({ color: "#ef4444" }).setLngLat(coords[coords.length - 1]).addTo(this.map)

      const bounds = coords.reduce(
        (b, c) => b.extend(c),
        new mapboxgl.LngLatBounds(coords[0], coords[0])
      )
      this.map.fitBounds(bounds, { padding: 40, maxZoom: 16 })
    })
  }
}
